module.exports = __webpack_public_path__ + "static/img/collegeTime.44ec30dd.2ee9909.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/collegeTime.44ec30dd.png
// module id = fwH0
// module chunks = 1